import * as THREE from '../../../libs/three.js/build/three.module.js';

export const workerMixin = {
    EptLazBatcher: {
        push(las: any) {
            const workerPath = Potree.scriptPath + '/workers/EptLaszipDecoderWorker.js';
            const worker = Potree.workerPool.getWorker(workerPath);

            worker.onmessage = (e) => {
                const g = new THREE.BufferGeometry();
                const numPoints = las.pointsCount;

                const positions = new Float32Array(e.data.position);
                const colors = new Uint8Array(e.data.color);

                const intensities = new Float32Array(e.data.intensity);
                const classifications = new Uint8Array(e.data.classification);
                const returnNumbers = new Uint8Array(e.data.returnNumber);
                const numberOfReturns = new Uint8Array(e.data.numberOfReturns);
                const pointSourceIDs = new Uint16Array(e.data.pointSourceID);
                const indices = new Uint8Array(e.data.indices);
                const gpsTime = new Float32Array(e.data.gpsTime);

                g.setAttribute('position', new THREE.BufferAttribute(positions, 3));
                g.setAttribute('rgba', new THREE.BufferAttribute(colors, 4, true));
                g.setAttribute('intensity', new THREE.BufferAttribute(intensities, 1));
                g.setAttribute('classification', new THREE.BufferAttribute(classifications, 1));
                g.setAttribute('return number', new THREE.BufferAttribute(returnNumbers, 1));
                g.setAttribute('number of returns', new THREE.BufferAttribute(numberOfReturns, 1));
                g.setAttribute('source id', new THREE.BufferAttribute(pointSourceIDs, 1));
                g.setAttribute('indices', new THREE.BufferAttribute(indices, 4));
                g.setAttribute('gpsTime', new THREE.BufferAttribute(gpsTime, 1));
                this.node.gpsTime = e.data.gpsMeta;

                g.attributes.indices.normalized = true;

                const tightBoundingBox = new THREE.Box3(
                    new THREE.Vector3().fromArray(e.data.tightBoundingBox.min),
                    new THREE.Vector3().fromArray(e.data.tightBoundingBox.max)
                );

                if (e.data.intensityRange) {
                    const attr = this.node.ept.pointAttributes.attributes.find((a: any) => a.name === 'intensity');
                    if (attr) {
                        attr.range[0] = Math.min(attr.range[0], e.data.intensityRange[0]);
                        attr.range[1] = Math.max(attr.range[1], e.data.intensityRange[1]);
                    }
                }

                this.node.doneLoading(g, tightBoundingBox, numPoints, new THREE.Vector3(...e.data.mean));

                Potree.workerPool.returnWorker(workerPath, worker);
            };

            const message = {
                buffer: las.arrayb,
                numPoints: las.pointsCount,
                pointSize: las.pointSize,
                pointFormatID: las.pointsFormatId,
                scale: las.scale,
                offset: las.offset,
                mins: las.mins,
                maxs: las.maxs,
            };

            worker.postMessage(message, [message.buffer]);
        },
    },
};
